import {ProductReviews} from "../components/firestrike/ProductReviews";
import {UsageGuide} from "../components/firestrike/UsageGuide";
import {ProductShowcase} from "../components/firestrike/ProductShowcase";
import {HeroSection} from "../components/firestrike/HeroSection";
import {HowToGuide} from "../components/firestrike/HowToGuide";

export const BolFireStrikePage = "https://www.bol.com/nl/nl/b/fire-strike/604066675/";
export const HomePage = (props: any) => {
    return (
        <div className="font-sans bg-ink-950 text-ink-100">
            <HeroSection />
            <ProductShowcase />
            <UsageGuide />
            <HowToGuide />
            <ProductReviews />
        </div>
    );
};
